import { render, staticRenderFns } from "./SubAccountBody.vue?vue&type=template&id=2f319562&scoped=true&"
import script from "./SubAccountBody.vue?vue&type=script&lang=ts&"
export * from "./SubAccountBody.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f319562",
  null
  
)

export default component.exports